import React from 'react';
import Quote from '../components/Quote';
import useFavorites from '../hooks/useFavorites';

const SavedPage = () => {
    const { favorites, toggleFavorite } = useFavorites();

    return (
        <div className="page-container">
            <h1>Saved Quotes</h1>
            <p className="page-subtitle">
                {favorites.length === 0
                    ? 'Quotes you like will appear here.'
                    : `${favorites.length} quote${favorites.length === 1 ? '' : 's'} saved`}
            </p>
            {favorites.length === 0 ? (
                <div className="saved-empty">
                    <span className="saved-empty-icon">♡</span>
                    <p>Hit the Like button on any quote to save it here.</p>
                </div>
            ) : (
                <div className="saved-list">
                    {favorites.map((q) => (
                        <Quote
                            key={q.savedAt}
                            quote={q}
                            liked={true}
                            onLike={() => toggleFavorite(q)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SavedPage;
